import React, { ReactNode } from "react";

import cn from "classnames";

import { Company, Person } from "@mapmycustomers/shared/types/entity";

import EntityAddressIssueWarning from "@app/component/EntityAddressIssue";
import EntityIncompleteAddressWarning from "@app/component/EntityIncompleteAddressWarning";
import AddressPart from "@app/enum/AddressPart";
import { SHORT_ADDRESS } from "@app/util/consts";
import { entityToAddressLines, formatCoordinates } from "@app/util/formatters";

import styles from "./Address.module.scss";

interface Props {
  entity: Company | Person;
  noAddressText?: ReactNode;
  parts?: AddressPart[];
  showWarning?: boolean;
}

const Address: React.FC<Props> = ({
  entity,
  noAddressText,
  parts = SHORT_ADDRESS,
  showWarning = false,
}) => {
  const { line1, line2, line3 } = entityToAddressLines(entity, parts);
  const coordinates = entity.geoPoint?.coordinates;
  return (
    <div className={styles.container}>
      <div>
        {line1 && (
          <div>
            {line1}
            {showWarning && !line2 && !line3 && entity.showInvalidAddressBanner && (
              <EntityIncompleteAddressWarning className={styles.warning} entity={entity} />
            )}
            {showWarning && !line2 && !line3 && entity.showInvalidGeoAddressBanner && (
              <EntityAddressIssueWarning />
            )}
          </div>
        )}
        {line2 && (
          <div>
            {line2}
            {showWarning && !line3 && entity.showInvalidAddressBanner && (
              <EntityIncompleteAddressWarning className={styles.warning} entity={entity} />
            )}
            {showWarning && !line3 && entity.showInvalidGeoAddressBanner && (
              <EntityAddressIssueWarning />
            )}
          </div>
        )}
        {line3 && (
          <div>
            {line3}
            {showWarning && entity.showInvalidAddressBanner && (
              <EntityIncompleteAddressWarning className={styles.warning} entity={entity} />
            )}
            {showWarning && entity.showInvalidGeoAddressBanner && <EntityAddressIssueWarning />}
          </div>
        )}
        {!line1 && !line2 && !line3 && noAddressText}
      </div>
      {coordinates ? (
        <span className={cn(styles.points, { [styles.noAddress]: !line1 && !line2 && !line3 })}>
          {formatCoordinates(coordinates)}
        </span>
      ) : null}
    </div>
  );
};

export default Address;
